<template>
  <modal :show="show" showLarge>
    <div slot="modalHeader">
      <modal-header :closeModal="close">Download History</modal-header>
    </div>
    <spinner-icon v-if="loading" />
    <hr />
    <download-table :tableData="downloads" v-bind:confirmId="confirmId" :creativeUnitName="title"/>
    <div slot="modalFooter">
      <modal-footer cancelText="Close" :closeModal="close" hideConfirmText/>
    </div>
  </modal>
</template>

<script>
import Modal from '@/components/Modal/modal'
import ModalHeader from '@/components/Modal/modal-header'
import ModalFooter from '@/components/Modal/modal-footer'
import ButtonCta from '@/components/Button/button'
import FormGroup from '@/components/Form/FormGroup/form-group'
import Field from '@/components/Form/Field/field'
import CreativeTable from '@/components/CreativeTable/creative-table'
import DownloadTable from '@/components/DownloadTable/download-table'
import SearchBox from '@/components/SearchBox/searchbox'
import SpinnerIcon from '@/components/SpinnerIcon/spinner'
import Notifications from '@/components/Notifications/notifications'

import {modalMixin} from '@/mixins/modalMixin'
import {downloadMixin} from '@/mixins/downloadMixin'
import {creativeMixin} from '@/mixins/creativeMixin'
import {notificationMixin} from '@/mixins/notificationMixin'

export default {
  name: 'modal_download_history',
  mixins: [modalMixin, downloadMixin, creativeMixin, notificationMixin],
  components: {
    Modal,
    ModalHeader,
    ModalFooter,
    ButtonCta,
    FormGroup,
    Field,
    CreativeTable,
    DownloadTable,
    SearchBox,
    SpinnerIcon,
    Notifications
  },
  props: {
    show: Boolean,
    confirmId: String,
    title: String
  },
  data: () => ({
    polling: {
      time: 10000
    },
    errors: {
      name: ''
    }
  }),
  watch: {
    show: 'getDownloads'
  },
  computed: {
    creativeId () {
      return this.$route.params.id
    }
  },
  methods: {
    reloadDownloads () {
      this.getCreativeDownloads(this.creativeId).then(() => {
        if (this.downloads.some(d => d.status === 'created' || d.status === 'in_progress' || (d.type === 'move' && d.status !== 'created')) && this.show) {
          setTimeout(() => this.reloadDownloads(), this.polling.time)
        }
      }, error => {
        this.addNotification('danger', error)
        this.finishLoading()
      })
    },
    getDownloads () {
      this.startLoading()
      this.getCreativeDownloads(this.creativeId).then(() => {
        this.finishLoading()
        if (this.downloads.some(d => d.status === 'created' || d.status === 'in_progress' || (d.type === 'move' && d.status !== 'created')) && this.show) {
          setTimeout(() => this.reloadDownloads(), this.polling.time)
        }
      }, error => {
        this.addNotification('danger', error)
        this.finishLoading()
      })
    }
  }
}
</script>

<style lang="scss">
.asset {
  overflow: hidden;
  position: relative;
  margin-bottom: 20px;
  border-radius: 3px;
  border: solid #e1e1e1 1px;

  .asset__img {
    background-color: #ccc;
    background-image: linear-gradient(45deg, rgba(0, 0, 0, .2) 25%, transparent 25%, transparent 75%, rgba(0, 0, 0, .2) 75%, rgba(0, 0, 0, .2)), linear-gradient(45deg, rgba(0, 0, 0, .2) 25%, transparent 25%, transparent 75%, rgba(0, 0, 0, .2) 75%, rgba(0, 0, 0, .2));
    background-size: 10px 10px;
    background-position: 0 0, 5px 5px;
    padding: 5px;
    height: 170px;
    img {
      width: 100%;
      height: 100%;
      object-fit: scale-down;
    }
    position: relative;
    overflow: hidden;
  }

  .asset__trash {
    position: absolute;
    top: 10px;
    right: 4px;
    background-color: #2c3247;
    width: 28px;
    height: 28px;
    display: flex;
    align-items: center;
    justify-content: center;
    .fa {
      font-size: 20px;
      color: #DDD;
    }
  }

  .asset__video {
    position: absolute;
    top: 10px;
    left: 4px;
    background-color: #2c3247;
    width: 28px;
    height: 28px;
    display: flex;
    align-items: center;
    justify-content: center;
    .fa {
      font-size: 20px;
      color: #DDD;
    }
  }

  .asset__info {
    padding: 5px;
    text-align: center;
  }

  .asset__info_table {
    display: table;
    width: 100%;
    height: 100%;

    span {
      display: table-cell;
      vertical-align: middle;
      text-align: center;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Modal/downloads/modal-download-history.vue